export default "a8171f555959ef90.png"